var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_90_489)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6953 0.5C14.7332 0.5 15.661 0.556998 16.2119 0.604492V3.15234L14.6426 3.15332C13.7634 3.15332 13.0992 3.36107 12.6807 3.8584C12.2786 4.33635 12.2041 4.96956 12.2041 5.55664V8.55371H16.0068L15.6318 11.4658H12.2041V21.5H9.16504V11.4658H5.78809V8.55371H9.16504V5.16895C9.16509 3.59925 9.64244 2.44625 10.4121 1.68555C11.1834 0.923303 12.3038 0.500033 13.6953 0.5Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_90_489"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.49185efd1be032f96621eb2a7a19be76.svg";
export { ForwardRef as ReactComponent };